
<template>
  <v-app-bar-nav-icon v-if="show && !li"
                      @click="incrmentTrigger()">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-text="'mdi-menu'"
                v-bind="attrs"
                v-on="on" />
      </template>
      <span v-text="extended ? $t('servicesystem.common_objects.commonterms.minimize_menu') : $t('servicesystem.common_objects.commonterms.expand_menu')" />
    </v-tooltip>
  </v-app-bar-nav-icon>
  <v-list v-else-if="li" class="pa-0 nav-trigger-li">
    <v-list-item @click="incrmentTrigger()" style="min-height: 0px;" class="px-3">
      <v-list-item-icon class="mr-4 mb-1 mt-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs"
                    v-on="on"
                    size="18">{{extended ? 'mdi-arrow-collapse-horizontal' : 'mdi-arrow-expand-horizontal'}}</v-icon>
          </template>
          <span v-text="$t('servicesystem.common_objects.commonterms.expand_menu')" />
        </v-tooltip>
      </v-list-item-icon>
      <v-list-item-content v-text="$t('servicesystem.common_objects.commonterms.minimize_menu')" class="py-0" />
    </v-list-item>
  </v-list>
</template>


<script>
export default {
  props: ["persistant", "li"],

  methods: {
    incrmentTrigger() {
      this.$store.dispatch("navstore/triggerNavMenu");
    },
  },

  computed: {
    extended() {
      return this.$store.getters["navstore/Extended"];
    },

    show() {
      if (this.isPadBool || this.persistant) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
/*
@media only screen and (max-width: 1400px) and (min-width: 1000px) {
  .nav-trigger-li {
    display: none !important;
  }
}
*/
</style>
